export default [
    {
        // [0]
        key: "fecha",
        label: "Fecha",
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        // [1]
        key: "descripcion",
        label: "Descripción",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [2]
        key: "estado",
        label: "Estado",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [3]
        key: "archivo",
        label: "Archivo",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [3]
        key: "created_at",
        label: "Fecha de Creación",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [3]
        key: "comentario_revisor",
        label: "Comentario del Revisor",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [4]
        key: "remunerable",
        label: "Remunerable",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [4]
        key: "actions",
        label: "Acciones",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
]